export default {
  title: "基礎資訊",
  caseType: "案件類型",
  creator: "創建人",
  createTime: "創建時間",
  updateTime: "更新時間",
  description: "案件說明",
};
